import { maxChars } from './maxChars';

export const max255Chars = maxChars(255);
